<template>
  <div id="app">
    <div class="login_box_all">
      <div class="login_logo hidden-sm-and-down">
        <img src="../../assets/images/login_logo.png" />
      </div>
      <div class="text-center login_title">
        《{{ $store.state.Name }}》在线投稿系统 —
        <span class="highorange">专家登录</span>
      </div>
      <div class="container login_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="专家免密登录" name="first" class="ten">
            <el-form
              ref="form"
              :model="form"
              label-width="80px"
              class="twenfive"
            >
              <el-form-item label="验证码:">
                <el-col>
                  <el-input
                    v-model="form.name"
                    placeholder="请输入验证码"
                  ></el-input>
                  <div class="msg_right">验证码为审稿邀请邮件的验证码</div>
                </el-col>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary">登录</el-button>
                <div class="clearfix"></div>
                <div class="leftfloat highgreen" style="margin-left: 3px">
                  <i class="el-icon-success"></i> 登录成功！
                </div>
                <div class="rightfloat">
                  <a href="" class="highblue">返回首页</a>
                </div>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <div class="login_other fifth">
          <p class="text-center">没有账号?<a href="">立即注册</a></p>
          <p class="text-center">
            使用其他方式登录&nbsp;&nbsp;<a href="">返回首页</a>
          </p>
          <p class="text-center">
            已经有QQ、微信账号，可直接登录，不用重复注册。
          </p>
          <div class="clearfix"></div>
          <div class="login_other_button">
            <div
              class="weixin"
              onmouseover="this.className = 'weixin on';"
              onmouseout="this.className = 'weixin';"
            >
              <a href="javascript:;"
                ><img
                  @mouseenter="wxshow()"
                  src="../../assets/images/add_wx1.png"
              /></a>
              <div class="weixin_nr" v-if="showWx">
                <!--<img src="../../assets/images/weixin.jpg" width="150" height="150" />-->
                <Login_WeiXin />
              </div>
            </div>
            <a href="" class="qq_login" v-if="IsQQLogin"
              ><img src="../../assets/images/add_qq1.png"
            /></a>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="container login_bottom text-center">
        版权所有@ 陕西《{{ $store.state.Name }}》杂志社有限公司
      </div>
    </div>
  </div>
</template>

<script>
import Login_WeiXin from '../../components/Login/Login_WeiXin'
export default {
  name: 'login',
  data() {
    return {
      showWx: false,
      activeName: 'first',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
    }
  },
  components: {
    Login_WeiXin,
  },
  methods: {
    wxshow() {
      this.showWx = true
    },
    handleClick(tab, event) {},
  },
}
</script>

<style scoped></style>
